export enum FeatureFlags {
  EnableLyearnConnect = 'enable-lyearn-connect',
  EnableOneOnOne = 'enable-one-on-one',
  EnableOKR = 'enable-okr',
  EnableDepartments = 'enable-departments',
  EnableActivity = 'enable-activity',
  EnableSkillMatrix = 'enable-skill-matrix',
  EnableSelfLearningContent = 'enable-self-learning-content',
  EnablePraise = 'enable-praise',
  EnableMeeting = 'enable-meeting',
  EnableFeedback = 'enable-feedback',
  EnableHabits = 'enable-habits',
  ShowUserProfile = 'show-user-profile',
  EnableMarketplaceContent = 'enable-marketplace-content',
  EnableSharedCourseDuplication = 'enable-shared-course-duplication',
  EnableReports = 'enable-reports',
  EnableOnboarding = 'enable-onboarding',
  EnableContextualHomepage = 'enable-contextual-homepage',
  EnableLyearnAI = 'enable-lyearn-ai',
  EnableExternalContent = 'enable-external-content',
  EnabledMGSAOnboarding = 'enable-mgsa-onboarding',
  EnabledQuizSyncSkillScore = 'enable-quiz-sync-skill-score',
  EnabledReviewV2 = 'enable-reviews-v2',
  EnableUserSurvey = 'enable-user-survey',
  EnableUserSurveyCadenceCustomFrequency = 'enable-user-survey-cadence-custom-frequency',
  OnlyAllowInIframe = 'only-allow-in-iframe',
  EnableSubWorkspacesForQuestions = 'enable-subworkspaces-for-questions',
  EnablePublicFeedbackSurvey = 'enable-public-feedback-survey',
  EnableMultiLanguage = 'enable-multi-lang',
  EnableMultiLanguageContent = 'enable-multi-lang-content',
  EnableOverviewTab = 'enable-employee-overview-tab',
  EnableLearnerProfileJoinedDate = 'enable-profile-join-date',
  DefaultRestricted = 'default-restricted',
  DisableFeedback = 'disable-feedback',
  AutoRedirection = 'auto-redirection',
  EnableEmployeeJourney = 'enable-employee-journey',
  DisableContentAccessEventOnCompletion = 'disable-content-access-event-on-completion',
  RemoveCourseCover = 'remove-course-cover',
  EnablePathEditorDueDate = 'enable-path-editor-due-date',
  EnablePathOptionalContent = 'enable-path-optional-content',
  EnableDownloadVideo = 'enable-download-video',
  EnableFeedbackAfterNDays = 'enable-feedback-after-n-days',
  EnableBadges = 'enable-badges',
  EnablePoints = 'enable-points',
  EnablePerformanceReviews = 'enable-performance-reviews',
  EnableLearnModule = 'enable-learn-module',
  EnableEngageModule = 'enable-engage-module',
  EnablePerformModule = 'enable-perform-module',
  EnableSubscriptionManagement = 'enable-subscription-management',
  EnableKnowledgeBase = 'enable-knowledge-base',
  EnableKnowledgeBaseTeachMode = 'enable-knowledge-base-teach-mode',
  EnableBlogs = 'enable-blogs',
  EnableFaceVerification = 'enable-face-verification',
  EnableKnowledgeAsset = 'enable-knowledge-asset',
  EnableAICourseCreator = 'enable-ai-course-creator',
  EnableContentRecommendation = 'enable-content-recommendation',
  EnableGamification = 'enable-gamification',
  EnableCompactHomepage = 'enable-compact-homepage',
  EnableClientsTask = 'client-task',
  EnableTaskTimer = 'enable-task-timer',
  EnableAiMGSACreation = 'enable-ai-mgsa-creation',
  EnableDesignation = 'enable-designation',
  EnableStreaksCustomFrequency = 'enable-streaks-custom-frequency',
  EnableLeaderboardsCustomFrequency = 'enable-leaderboards-custom-frequency',
  EnableTaskBulkOperations = 'enable-task-bulk-operations',
  EnableMicroLearning = 'enable-micro-learning',
  EnableUnifiedDashboard = 'enable-unified-dashboard',
  EnableProjectManagementPreReleaseFeatures = 'enable-project-management-pre-release-features',
  EnableTaskKanbanView = 'enable-task-kanban-view',
  EnableProfileMGSAListing = 'enable-profile-mgsa-listing',
  EnableAllTasksTab = 'enable-all-tasks-tab',
  EnableTaskQuickView = 'enable-task-quick-view',
  EnableMgsaPreReleaseFeatures = 'enable-mgsa-pre-release-features',
  EnableAIVideoGeneration = 'enable-ai-video-generation',
  EnableRoleplay = 'enable-roleplay',
  EnableLearnerSessions = 'enable-learner-sessions',
  EnableProductivityModel = 'enable-productivity-model',
}
